export default __webpack_public_path__ + "static/media/CF.3155e7f5.svg";